/**
 * Starter Popover — wraps Mantine's `<Popover>` so the dropdown surface
 * matches Menu / Modal (radius-lg + shadow-2 + bg-surface). Lightweight —
 * structural only, no behaviour change.
 *
 * Compound parts (Target, Dropdown) re-exposed for parity with Mantine.
 */
import type { ReactElement } from 'react';
import {
  Popover as MantinePopover,
  type PopoverProps as MantinePopoverProps,
} from '@mantine/core';
import styles from './Popover.module.css';

export interface PopoverProps extends MantinePopoverProps {}

function PopoverRoot({ classNames, ...rest }: PopoverProps): ReactElement {
  const existing = (classNames ?? {}) as {
    dropdown?: string;
    arrow?: string;
  };
  const mergedClassNames = {
    ...existing,
    dropdown: [styles.dropdown, existing.dropdown].filter(Boolean).join(' '),
    arrow: [styles.arrow, existing.arrow].filter(Boolean).join(' '),
  };
  return <MantinePopover classNames={mergedClassNames} {...rest} />;
}

export const Popover = Object.assign(PopoverRoot, {
  Target: MantinePopover.Target,
  Dropdown: MantinePopover.Dropdown,
});
